// import React, { useEffect, useState } from "react";
// import characterWave from "../assest/Wave.gif";
// import Reading_in from "../assest/Reading/Reading_IN.gif";
// import Reading_loop from "../assest/Reading/Reading_Loop.gif";
// import Reading_out from "../assest/Reading/Reading_OUT.gif";
// import Thinking_in from "../assest/Thinking/Thinking_IN.gif";
// import Thinking_loop from "../assest/Thinking/Thinking_Loop.gif";
// import Thinking_out from "../assest/Thinking/Thinking_OUT-2.gif";


//   // Animation durations in ms
//   const durations = {
//     wave: 5000, // aap wave ko ek dafa chalana chahte ho
//     reading_in: 1020,
//     reading_out: 870,
//     thinking_in: 810,
//     thinking_out: 900,
//   };

// const CharacterDisplay = ({ loading }) => {
//   const [stage, setStage] = useState("wave");

//   // Initial sequence
//   useEffect(() => {
//     if (stage === "wave") {
//       const timer = setTimeout(() => setStage("reading_in"), durations.wave);
//       return () => clearTimeout(timer);
//     }
//     if (stage === "reading_in") {
//       const timer = setTimeout(() => setStage("reading_loop"), durations.reading_in);
//       return () => clearTimeout(timer);
//     }
//   }, [stage]);

//   // Handle question asked
//   useEffect(() => {
//     if (loading && stage === "reading_loop") {
//       setStage("reading_out");
//     }
//   }, [loading, stage]);

//   useEffect(() => {
//     let timer;
//     if (stage === "reading_out") {
//       timer = setTimeout(() => setStage("thinking_in"), durations.reading_out);
//     } else if (stage === "thinking_in") {
//       timer = setTimeout(() => setStage("thinking_loop"), durations.thinking_in);
//     }
//     return () => clearTimeout(timer);
//   }, [stage]);

//   // Handle response
//   useEffect(() => {
//     let timer;
//     if (!loading && stage === "thinking_loop") {
//       setStage("thinking_out");
//     } else if (stage === "thinking_out") {
//       timer = setTimeout(() => setStage("reading_in"), durations.thinking_out);
//     } else if (stage === "reading_in") {
//       timer = setTimeout(() => setStage("reading_loop"), durations.reading_in);
//     }
//     return () => clearTimeout(timer);
//   }, [loading, stage]);

//   let imageSrc;
//   switch (stage) {
//     case "wave":
//       imageSrc = characterWave;
//       break;
//     case "reading_in":
//       imageSrc = Reading_in;
//       break;
//     case "reading_loop":
//       imageSrc = Reading_loop;
//       break;
//     case "reading_out":
//       imageSrc = Reading_out;
//       break;
//     case "thinking_in":
//       imageSrc = Thinking_in;
//       break;
//     case "thinking_loop":
//       imageSrc = Thinking_loop;
//       break;
//     case "thinking_out":
//       imageSrc = Thinking_out;
//       break;
//     default:
//       imageSrc = Reading_loop;
//   }

//   return (
//     <img
//       src={imageSrc}
//       alt="Character"
//       className="w-full h-full object-cover relative z-[-1]"
//     />
//   );
// };


// export default CharacterDisplay;

import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import characterWave from "../assest//Nerdy Think Read GIF/Wave.mp4";
import Reading_in from "../assest/Nerdy Think Read GIF/Reading_IN.mp4";
import Reading_loop from "../assest/Nerdy Think Read GIF/Reading_Loop.mp4";
import Reading_out from "../assest/Nerdy Think Read GIF/Reading_OUT.mp4";
import Thinking_in from "../assest//Nerdy Think Read GIF/Thinking_IN.mp4";
import Thinking_loop from "../assest/Nerdy Think Read GIF/Thinking_Loop.mp4";
import Thinking_out from "../assest/Nerdy Think Read GIF/Thinking_OUT.mp4";

const CharacterDisplay = ({ loading }) => {
  const [stage, setStage] = useState("wave");
  const [activePlayer, setActivePlayer] = useState(0);

  const player0 = useRef(null);
  const player1 = useRef(null);
  const players = [player0, player1]; // keep plain array

  const videoData = useMemo(() => {
    switch (stage) {
      case "wave": return { src: characterWave, loop: false };
      case "reading_in": return { src: Reading_in, loop: false };
      case "reading_loop": return { src: Reading_loop, loop: true };
      case "reading_out": return { src: Reading_out, loop: false };
      case "thinking_in": return { src: Thinking_in, loop: false };
      case "thinking_loop": return { src: Thinking_loop, loop: true };
      case "thinking_out": return { src: Thinking_out, loop: false };
      default: return { src: Reading_loop, loop: true };
    }
  }, [stage]);

  const { src: videoSrc, loop: videoLoop } = videoData;

  const getNextStage = useCallback(
    (current) => {
      switch (current) {
        case "wave": return "reading_in";
        case "reading_in": return "reading_loop";
        case "reading_loop": return loading ? "reading_out" : "reading_loop";
        case "reading_out": return "thinking_in";
        case "thinking_in": return "thinking_loop";
        case "thinking_loop": return loading ? "thinking_loop" : "thinking_out";
        case "thinking_out": return "reading_in";
        default: return "reading_loop";
      }
    },
    [loading]
  );

  // react to loading change
  useEffect(() => {
    if (loading && stage === "reading_loop") setStage("reading_out");
    if (!loading && stage === "thinking_loop") setStage("thinking_out");
  }, [loading, stage]);

  // handle video playback and transitions
  useEffect(() => {
    const nextPlayerIndex = (activePlayer + 1) % 2;
    const player = players[nextPlayerIndex].current;
    if (!player) return;

    player.src = videoSrc;
    player.loop = videoLoop;
    player.currentTime = 0;

    const handleCanPlay = () => player.play().catch(err => console.warn(err));
    const handleEnded = () => setStage(getNextStage(stage));

    player.addEventListener("canplay", handleCanPlay, { once: true });
    player.addEventListener("ended", handleEnded);
    player.load();

    setActivePlayer(nextPlayerIndex);

    return () => {
      player.removeEventListener("canplay", handleCanPlay);
      player.removeEventListener("ended", handleEnded);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stage, videoSrc, videoLoop]); // only these dependencies

  return (
    <div className="relative w-full h-full">
      {[0, 1].map((i) => (
        <video
          key={i}
          ref={players[i]}
          muted
          playsInline
          autoPlay
          className={`absolute inset-0 w-full h-full object-cover ${activePlayer === i ? "z-10" : "z-0"}`}
        />
      ))}
    </div>
  );
};

export default CharacterDisplay;
